import { snakeCase } from 'snake-case'

function walk (obj) {
  if (!obj || typeof obj !== 'object') return obj
  if (isDate(obj) || isRegex(obj)) return obj

  if (Array.isArray(obj)) return obj.map(walk)

  return Object.keys(obj).reduce(function (acc, key) {
    // Some visual settings are snake case, but some aren't and the viz code
    // really, really cares about which.
    acc[snakeCase(key)] = key === 'legacyVisualSettings'
      ? obj[key]
      : walk(obj[key])
    return acc
  }, {})
}

const isDate = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Date]'
}

const isRegex = function (obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]'
}

/**
 * Used, primarily, to convert Redux objects (camelCase) to Backbone (snake_case) style
 * as all of our legacy models and views expect snake_case attributes
 */
export default function (obj) {
  if (typeof obj === 'string') return snakeCase(obj)
  return walk(obj)
}
